<template>
  <!-- 設定画面 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>設定</h2>
      </CCardHeader>
      <CCardBody>
        <div class="container">
          <table class="table table-bordered" style="max-width: 800px">
            <tr>
              <td colspan="2">
                <h5 class="section-title mt-2 mb-2">基本情報</h5>
              </td>
            </tr>
            <tr>
              <th scope="row">会社名</th>
              <td>{{ items.company_name }}</td>
            </tr>
            <tr>
              <th scope="row">電話番号</th>
              <td>{{ items.telephone }}</td>
            </tr>
            <tr>
              <th scope="row">定時前打刻猶予時間</th>
              <td>{{ items.pre_buffer }}</td>
            </tr>
            <tr>
              <th scope="row">定時後打刻猶予時間</th>
              <td>{{ items.post_buffer }}</td>
            </tr>
            <tr>
              <th scope="row" v-html="postBufferBreakHeader"></th>
              <td>{{ items.post_work_break_flg ? 'はい' : 'いいえ' }}</td>
            </tr>
            <tr>
              <th scope="row">勤務時間の最小単位</th>
              <td>{{ items.work_time_unit }}</td>
            </tr>
            <tr>
              <th scope="row">規定定時間</th>
              <td>{{ items.work_basic }}</td>
            </tr>
            <tr>
              <th scope="row">規定休憩時間</th>
              <td>{{ items.break_basic }}</td>
            </tr>
            <tr>
              <th scope="row" v-html="projectBreakHeader"></th>
              <td>{{ items.use_project_break_flg ? 'はい' : 'いいえ' }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h5 class="section-title mt-2 mb-2">Slack通知</h5>
              </td>
            </tr>
            <tr>
              <th scope="row">workspaceトークン</th>
              <td>{{ items.slack_token }}</td>
            </tr>
            <tr>
              <th scope="row">チャンネルID</th>
              <td>{{ items.slack_channel }}</td>
            </tr>
          <!-- 有休付与ルール（年数 ↔ 付与日数） -->
          <tr>
            <td colspan="2">
              <h5 class="section-title mt-4 mb-2">有休付与</h5>

              <!-- （1）通常の労働者 -->
              <div class="mb-1">
                <label class="mb-0">
                  （1）通常の労働者の付与日数
                </label>
              </div>
              <table class="table table-bordered mb-3">
                <tr>
                  <th class="plr-rowhead">継続勤務年数（年）</th>
                  <th
                    v-for="(c,i) in paidLeaveNormalColumns"
                    :key="'n-h'+i"
                    class="plr-colhead text-center"
                  >
                    {{ c.label }}
                  </th>
                </tr>
                <tr>
                  <th class="plr-rowhead">付与日数（日）</th>
                  <td
                    v-for="(c,i) in paidLeaveNormalColumns"
                    :key="'n-d'+i"
                    class="text-center"
                  >
                    {{ c.days }}
                  </td>
                </tr>
              </table>

              <!-- （2）週4日以下かつ週30時間未満 -->
              <div class="mb-1">
                <label class="mb-0">
                  （2）週所定労働日数が4日以下かつ週所定労働時間が30時間未満の労働者の付与日数
                </label>
              </div>
              <table class="table table-bordered mb-1">
                <tr>
                  <th rowspan="2" class="plr-rowhead text-center">週所定<br />労働日数</th>
                  <th rowspan="2" class="plr-rowhead text-center">1年間の<br />所定労働日数※</th>
                  <th colspan="7" class="plr-rowhead text-center">継続勤務年数（年）</th>
                </tr>
                <tr>
                  <th
                    v-for="(c,i) in paidLeaveShortColumns"
                    :key="'s-h'+i"
                    class="plr-colhead text-center"
                  >
                    {{ c.label }}
                  </th>
                </tr>

                <tr v-for="r in paidLeaveShortRows" :key="'s-r'+r.weeklyDays">
                  <th class="plr-rowhead">
                    <label class="mb-0">
                      {{ r.weeklyDays }}日
                    </label>
                  </th>
                  <td class="text-center">{{ r.annualRange }}</td>
                  <td
                    v-for="(c,i) in paidLeaveShortColumns"
                    :key="'s-d'+r.weeklyDays+'-'+i"
                    class="text-center"
                  >
                    {{ r.days[c.key] }}
                  </td>
                </tr>
              </table>
              <div class="text-muted small">※週以外の期間によって労働日数が定められている場合</div>
            </td>
          </tr>
          </table>
          <div class="text-center mt-4">
            <router-link :to="{ name: SettingUpdate, params: { value: items } }">
              <button class="btn btn-info">編集</button>
            </router-link>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
import ConstList from "../ConstList";
export default {
  name: "info",
  data() {
    return {
      // 取得してきたクライアント情報のリスト
      items: {
      company_name: "",
      telephone: "",
      pre_buffer: "",
      post_buffer: "",
      work_time_unit: "",
      work_basic: "",
      break_basic: "",
      post_work_break_flg: false,
      use_project_break_flg: false,
      slack_token: "",
      slack_channel: "",
    },
      errors: [],
      SettingUpdate: "",
      clientInfo: "",
      // 二重サブミット対処フラグ
      submit_flg: false,
    };
  },
  computed: {
    postBufferBreakHeader() {
    const label = '定時後打刻猶予時間を休憩とする';
    if (window.innerWidth <= 768) {
      return '定時後打刻猶予時間を<br>休憩とする';
    }
    return label;
  },
    projectBreakHeader() {
      const label = 'プロジェクト設定の休憩時間を自動設定する';
      // スマホ判定
      if (window.innerWidth <= 768) {
        return 'プロジェクト設定の<br>休憩時間を自動設定する';
      }
      return label;
    },
    // （1）通常の労働者：継続勤務年数（年）→付与日数（日）
    paidLeaveNormalColumns() {
      return [
        { key: "0.5", label: "0.5", days: 10 },
        { key: "1.5", label: "1.5", days: 11 },
        { key: "2.5", label: "2.5", days: 12 },
        { key: "3.5", label: "3.5", days: 14 },
        { key: "4.5", label: "4.5", days: 16 },
        { key: "5.5", label: "5.5", days: 18 },
        { key: "6.5", label: "6.5以上", days: 20 },
      ];
    },

    // （2）短時間：列（継続勤務年数）
    paidLeaveShortColumns() {
      return [
        { key: "0.5", label: "0.5" },
        { key: "1.5", label: "1.5" },
        { key: "2.5", label: "2.5" },
        { key: "3.5", label: "3.5" },
        { key: "4.5", label: "4.5" },
        { key: "5.5", label: "5.5" },
        { key: "6.5", label: "6.5以上" },
      ];
    },

    // （2）短時間：行（週所定労働日数×所定労働日数）→付与日数（日）
    paidLeaveShortRows() {
      return [
        {
          weeklyDays: 4,
          annualRange: "169日〜216日",
          days: { "0.5": 7, "1.5": 8, "2.5": 9, "3.5": 10, "4.5": 12, "5.5": 13, "6.5": 15 },
        },
        {
          weeklyDays: 3,
          annualRange: "121日〜168日",
          days: { "0.5": 5, "1.5": 6, "2.5": 6, "3.5": 8, "4.5": 9, "5.5": 10, "6.5": 11 },
        },
        {
          weeklyDays: 2,
          annualRange: "73日〜120日",
          days: { "0.5": 3, "1.5": 4, "2.5": 4, "3.5": 5, "4.5": 6, "5.5": 6, "6.5": 7 },
        },
        {
          weeklyDays: 1,
          annualRange: "48日〜72日",
          days: { "0.5": 1, "1.5": 2, "2.5": 2, "3.5": 2, "4.5": 3, "5.5": 3, "6.5": 3 },
        },
      ];
    },

  },
  created() {
    this.SettingUpdate = ConstList.ROUTE_SETTING_UPDATE;
  },

  methods: {
    callList: function () {
      {
        axios
          .get((process.env.VUE_APP_API_ORIGIN) + '/setting/info')
          .then((response) => {
            this.items = response.data;
            if (this.items.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },

    // モーダルを表示
    openModal: function (item) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.showModal = true;
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
  },
};
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
